import defineRule from '../defineRule';
defineRule('max', (value, [max]) => {
    return typeof value === 'string'
        ? value.length > parseInt(max, 10)
            ? `Your text is too long (${value.length}).   Maximum length is ${max}.`
            : true
        : false;
});
